import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import studygameActions from '../../store/actions/studygameActions'
import Dictionary from '../../assets/content/dictionary/news-dictionary'
import Button from '../Button'
import Loading from '../Loading'
import NewsGame from './NewsGame'
import GameButtons from './GameButtons'

function shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}

const GuessWord = ({ news }) => {
    const [state, setState] = useState({
        isLoading: true,
        words: [],
        wordsToGet: 3,
        didAnswer: false,
        answerNumber: null
    })

    useEffect(() => {
        const titleWords = news.title.split(" ");
        const newsIndex = allNews.findIndex(article => article.title === news.title)
        let usableWords = [];
        let returnTitleWord = "";
        let returnFilteredString = "";
        let returnCharacters = "";
        let returnStuff = "";
        let wordsDb = shuffle(Dictionary.PT);
        let words = []
        let falseWordsIndex = []

        for (let item of titleWords) {
            let chosenString = item;
            if (usableWords.length === 0 || chosenString.length > 6) {
                usableWords.push(chosenString);
            }
            usableWords = shuffle(usableWords)
        }

        returnTitleWord = usableWords[0];
        words.push({ word: returnTitleWord, isRight: true })

        for (let item of returnTitleWord) {
            returnCharacters += `${item}`;
            // eslint-disable-next-line
            returnFilteredString = returnCharacters.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>0123456789ãáàâçéêíõóôúü\{\}\[\]\\\/]/gi, 'a')
        }

        for (let letter of returnFilteredString) {
            returnStuff += `${letter.replace(/[a-zA-Z0-9]+/g, '-')}`
        }

        //generate random unique numbers
        while (falseWordsIndex.length < state.wordsToGet) {
            var r = Math.floor(Math.random() * allNews.length - 1) + 1;
            if (falseWordsIndex.indexOf(r) === -1 && r !== newsIndex) falseWordsIndex.push(r);
        }

        falseWordsIndex.forEach((item) => {
            words.push({ word: wordsDb[item], isRight: false })
        })

        setState({
            ...state,
            isLoading: false,
            words: shuffle(words),
            replaceWord: returnTitleWord,
            filteredString: returnStuff
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAnswer = (sentWord, index) => {
        setState({
            ...state,
            didAnswer: true,
            answerNumber: index
        })

        setTimeout(() => {
            if (sentWord) {
                setTimeout(() => {
                    dispatch(studygameActions.finishMinigame())
                }, 1000)
            } else {
                setState({ ...state, didAnswer: false })
            }
        }, 1500)
    }

    const dispatch = useDispatch()
    const allNews = useSelector(state => state.studyGame.news)
    const { isLoading, didAnswer, answerNumber, words, replaceWord, filteredString } = state
    const disabledBtn = didAnswer ? true : false

    const changeNews = {
        ...news,
        title: news.title.replace(replaceWord, filteredString)
    }

    const studyGameState = useSelector(state => state.studyGame)
    const { currentRound } = studyGameState

    return (
        isLoading ? <Loading /> :
            <article className='white-container mb-4'>
                <NewsGame round={currentRound} news={changeNews} gameTitle='Selecione a palavra correta que encaixa no título!' />
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 py-8 md:py-10'>
                    {words.map((item, index) =>
                        <Button
                            key={index}
                            disabled={disabledBtn}
                            onClick={() => handleAnswer(item.isRight, index)}
                            className={`minigameButton px-6 py-4 w-full ${(disabledBtn && answerNumber === index) && item.isRight ? "btn-success" : (disabledBtn && answerNumber === index) && "btn-error"}`}
                        >
                            {item.word}
                        </Button>
                    )}
                </div>
                <GameButtons />
            </article >
    )
}

export default GuessWord